import React, { useState, useEffect } from 'react';
import './style.scss';
import { Input } from 'reactstrap'
import Loader from 'components/Loader';

function FeedsList(props) {
    const [searchValue, setSearchValue] = useState('');
    const [visibleFeeds, changeVisibleFeeds] = useState([]);

    useEffect(() => {
        changeVisibleFeeds(props.feeds);
        setSearchValue('');
    }, [props.feeds])

    const handleSearchChange = (value) => {
        if (value === '') {
            setSearchValue('');
            changeVisibleFeeds([...props.feeds]);
        } else {
            const visibleList = props.feeds.filter(item => item.attachedName.toLowerCase().includes(value.toLowerCase()));
            changeVisibleFeeds(visibleList);
            setSearchValue(value);
        }
    }

    return (
        <div className="feeds_list-container">
            <div className="reader-block_header-container">
                <h2 className="reader-block_header">Entities</h2>
            </div>
            {props.feeds.length > 0 &&
                <div className="reader-input-container">
                    <Input
                        style={{ backgroundColor: 'rgb(228, 229, 230)' }}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        value={searchValue}
                        placeholder="Search by Entity name"
                        type="text"
                        className="searchInput reader-input"
                    />
                    {!searchValue ?
                        <i style={{ cursor: 'default' }} className="fa fa-search search-container_icon" />
                    :
                        <i onClick={() => handleSearchChange('')} className="fa fa-times-circle search-container_icon" />
                    }
                </div>
            }
            {props.feedsLoading ? (
                <div className="reader-list_loader-container" style={{ borderTop: '1px solid rgb(228, 229, 230)' }}>
                    {/*<i className="fa fa-spinner fa-spin" />*/}
                    <Loader small />
                </div>
            ) : (
                <div className="feeds_list-list_container">
                    {(visibleFeeds && visibleFeeds.length > 0) ?
                    visibleFeeds.map(feed =>
                        <div
                            className="feeds_list-list_item-container"
                            style={feed.id === props.selectedFeed.id ? { backgroundColor: '#6f91bd' } : {}}
                            onClick={() => props.setSelectedFeed(feed)}
                            key={feed.id}
                        >
                            <div className="feeds_list-list_item-name">{feed.attachedName}</div>
                            <div className="feeds_list-list_item-counter">{feed.countNews}</div>
                        </div>
                    ) : (
                        <div style={{ padding: '10px 15px' }}>
                            No Newsfeeds found
                        </div>
                    )}
                </div>
            )}
            <div
                className="reader-block_footer-container flex-centered"
                style={{ borderTop: '1px solid rgb(228, 229, 230)', borderBottom: '1px solid rgb(49, 71, 132)' }}
            >
                <div>{(visibleFeeds && visibleFeeds.length) ? visibleFeeds.length : 'No'} Entities</div>
            </div>
        </div>
    );
}

export default FeedsList;